import { createAction } from 'redux-actions';
import { PapiDeviation } from '@wix/da-papi-types';
import { OriginalStatusType } from '../../types/originals';

export type ChangeOriginalStatusPayload = {
  deviation: PapiDeviation;
  status: OriginalStatusType;
};

export const changeOriginalStatus = createAction(
  '@@ORIGINALS.CHANGE_STATUS',
  (payload: ChangeOriginalStatusPayload) => payload
);

export const changeOriginalStatusSuccess = createAction(
  '@@ORIGINALS.CHANGE_STATUS_SUCCESS',
  (payload: PapiDeviation) => payload
);

export const toggleOriginalStatus = createAction(
  '@@ORIGINALS.TOGGLE_STATUS',
  (payload: PapiDeviation) => payload
);

